
































































import { Component } from 'vue-property-decorator';
import popupModule from '@/store/modules/common/popup.module';
import Mixin from '@/mixin';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';
import managerService from '@/services/common/manager.service';
import coachService from '@/services/common/coach.service';
import { Coach, User } from '@/store/models';
import managerModule from '@/store/modules/common/manager.module';
import coachModule from '@/store/modules/common/coach.module';

@Component({
  name: 'v-modal-confirmation'
})
export default class ModalConfirmation extends Mixin {
  get popup() {
    return popupModule.popup;
  }

  get isShowModal() {
    return popupModule.showPopup;
  }

  get replaceString() {
    if (popupModule.payload as User) {
      const user = popupModule.payload as User;
      if (user.firstName || user.lastName) {
        return `${(popupModule.payload as User).firstName} ${
          (popupModule.payload as User).lastName
        }`;
      } else if (user.coach && user.coach.firstName && user.coach.lastName) {
        return `${user.coach.firstName}
            ${user.coach.lastName}`;
      }
    } else if (popupModule.payload as Coach) {
    }
    if (popupModule.payload as string) {
      return popupModule.payload as string;
    }
    return '';
  }

  public async clickedYes() {
    switch (popupModule.popup?.action) {
      case 'go_home':
        await this.goHome();
        break;
      case 'login':
        await this.gotoLoginPage();
        break;
      case 'logout':
        await this.logout();
        break;
      case 'delete_coach':
        const coach = popupModule.payload as User;
        await coachService.deleteCoach(coach!.id || -1);
        await messageModule.showMessage({
          message: `${coach.coach?.firstName || ''} ${coach.coach?.lastName ||
            ''} has been deleted successfully`,
          type: MessageType.info
        });
        await coachModule.updateCoaches(
          coachModule.coaches.filter(m => m.id != coach.id),
          coachModule.paging
        );
        break;
      case 'delete_manager':
        const user = popupModule.payload as User;
        await managerService.deleteManager(user!.id || -1);

        await messageModule.showMessage({
          message: `${user.firstName || ''} ${user.lastName ||
            ''} has been deleted successfully`,
          type: MessageType.info
        });
        await managerModule.updateManager(
          managerModule.managers.filter(m => m.id != user.id),
          managerModule.paging
        );
        break;
      case 'close':
          break
      default:
        throw 'Not found action';
    }
    await popupModule.setShowPopup(false);
  }

  public clickedNo() {
    popupModule.setShowPopup(false);
  }
}
